import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: [],
    response: null,
    loading: false,
    error: null,
    count: 0,
    cardDataCount: null
};

//  GET ALL
export const getAllFieldVisit = createAsyncThunk(
    "getAllFieldVisit",
    async (body) => {
        try {
            const response = await instance.get(
                `/crm/field-visit/get-all-visits?page=${body?.page}&search=${body?.search}&startDate=${body?.startDate}&endDate=${body?.endDate}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

//  CREATE
export const CreateFieldVisit = createAsyncThunk(
    "CreateFieldVisit",
    async (data) => {
        try {
            const response = await instance.post(
                "/crm/field-visit/create-visit",
                data
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const updateFieldVisit = createAsyncThunk(
    "updateFieldVisit",
    async (formData) => {
        try {
            const response = await instance.post(
                "/crm/field-visit/update-visit",
                formData
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const FieldVisitSlice = createSlice({
    name: "FieldVisitSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        //  GET
        builder.addCase(getAllFieldVisit.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getAllFieldVisit.fulfilled, (state, action) => {
            state.loading = false;

            state.data = action.payload?.data || [];
            state.count = action.payload?.count || 0;
            state.cardDataCount = action.payload?.cardDataCount || null;
        });

        builder.addCase(getAllFieldVisit.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        //  CREATE
        builder.addCase(CreateFieldVisit.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(CreateFieldVisit.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });

        builder.addCase(CreateFieldVisit.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        //  Update
        builder.addCase(updateFieldVisit.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(updateFieldVisit.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });

        builder.addCase(updateFieldVisit.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});

export default FieldVisitSlice.reducer;